import { render } from "./existingDetails.vue?vue&type=template&id=60d10776&scoped=true"
import script from "./existingDetails.vue?vue&type=script&lang=js"
export * from "./existingDetails.vue?vue&type=script&lang=js"

import "./existingDetails.vue?vue&type=style&index=0&id=60d10776&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d10776"],['__file',"src/components/createProject/existingDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d10776"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d10776', __exports__)) {
    api.reload('60d10776', __exports__)
  }
  
  module.hot.accept("./existingDetails.vue?vue&type=template&id=60d10776&scoped=true", () => {
    api.rerender('60d10776', render)
  })

}


export default __exports__